<template>
    <div v-if="isMounted">
        <div class="card-body layout" :style="{'height': 300+'px'}">
            <div>
                <el-form :model="classForm" label-width="100px">

                    <el-form-item label="班级名称">
                        <el-input v-model="classForm.name" disabled  style="width: 200px"></el-input>
                    </el-form-item>

                    <el-form-item label="开始时间">
                        <el-input v-model="classForm.start_time"  style="width: 200px"></el-input>
                    </el-form-item>

                    <el-form-item label="时长（分钟）">
                        <el-input v-model="classForm.time" style="width: 200px"></el-input>
                    </el-form-item>

                    <el-form-item label="原因">
                        <el-input v-model="classForm.reason"  placeholder="请输入" style="width: 200px"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button size="small" @click="handleStore()" :loading="button_loading">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateSpecialClass",
        data() {
            return {
                path:'/student/',
                button_loading:false,
                title: '创建课程',
                loading: true,
                isMounted:false,
                classForm:{
                    name:'',
                    reason:'',
                    semester_id:'',
                    classPlanStudent_id:'',
                    teacher_id:'',
                    subject_id:'',
                    start_date:'',
                    classHeight:'',
                    start_time:'',
                    time:'',
                    date:''
                },
                coursePeriods:{},
                classrooms:'',

            }
        },
        mounted() {
            this.parentInfo =this.$parent.$parent;
            this.classForm.name=this.parentInfo.dialogData.name;
            this.classForm.start_date=this.parentInfo.dialogData.date;
            this.classForm.subject_id=this.parentInfo.dialogData.subject_id;
            this.classForm.teacher_id=this.parentInfo.dialogData.teacher_id;
            this.classForm.classHeight=this.parentInfo.dialogData.classHeight;
            this.classForm.start_time=this.parentInfo.dialogData.start_time;
            this.classForm.time=this.parentInfo.dialogData.time;
            this.classForm.semester_id=this.parentInfo.filter.semester_id;
            this.classForm.classPlanStudent_id=this.parentInfo.dialogData.classPlanStudent_id;
            this.classForm.name=this.parentInfo.dialogData.class_name;
            this.classForm.date=this.parentInfo.filter.date;
            this.isMounted=true;
            this.button_loading=false;
        },
        methods:{
            handleStore() {
                this.loading = true;
                this.button_loading=true;
                this.$wApi.send(this.path+this.parentInfo.dialogData.student_id, 'get_studentClassPlan_to_newClassPlan',
                    {'classForm': this.classForm, 'section_id': this.parentInfo.filter.section_id,'status':this.parentInfo.dialogData.status});
            },
        }
    }
</script>

<style scoped lang="scss">
    .layout{
        .left {
            float: left;
            width: 540px;
        }

        .right {
            margin-left:570px
        }
    }
    .modal{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index:3000;
    }
    .modal-dialog {
        max-width: 500px;
        margin: 30px auto;
    }
    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e9ecef;
    }
    .modal-header{
        font-size: 12px;
    }
    .modal-title {
        margin: 0;
        line-height: 1.5;
    }
    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 15px;
    }
    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0,0,0,.18);
        border-radius: .3rem;
        outline: 0;
        min-height: 300px;
        box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.12);
    }
    .modal .close {
        font-size: 20px;
        text-shadow: 0 1px 0 #fff;
    }
    .modal .close:hover {
        opacity: .5;
    }
</style>